import HubSideMenu from './hub-side-menu';

export default HubSideMenu;